import React, { useState } from "react";

export const CopyButton = ({ text, label, testId, className = "" }) => {
  const [copied, setCopied] = useState(false);
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={
        "inline-flex items-center justify-center gap-2 border border-white/15 hover:border-white/40 active:border-[#0066FF] text-white px-4 py-2.5 mono text-[11px] uppercase tracking-[0.18em] transition-colors w-full sm:w-auto " +
        className
      }
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        {copied ? (
          <path d="M5 12l5 5L20 7" />
        ) : (
          <>
            <rect x="9" y="9" width="13" height="13" rx="1" />
            <path d="M5 15V5a1 1 0 011-1h10" />
          </>
        )}
      </svg>
      <span>{copied ? "Copied" : label}</span>
    </button>
  );
};
